import React from 'react';
import Layout from "../Layout/layout";
import About from "../Pages/About";
import Banner from "../Pages/Banner";
import Contact1 from "../Pages/Contact1";
import Team1 from "../Pages/Team1";
import Service from "../Pages/Service";
import Video1 from "../Pages/Video1";
import News from "../Pages/News";
import Chooseus from "../Pages/Chooseus";
import Fundraise from "../Pages/Fundraise";
import Testimonial from "../Pages/Testimonial";
import ScrollToHash from '../ScrollToHash';

function Main() {
  return (
    <>
    
    <Layout headerStyle={1} footerStyle={1}>
    <ScrollToHash />
      <Banner id="banner" />
      <Service id="service"/>
      <About id="about" />
      <Fundraise id="fundraise" />
      <Chooseus id="chooseus" />
      {/* <Video1 id="video1" /> */}
      {/* <Team1 id="team" /> */}
      {/* <Testimonial id="testimonial" /> */}
      {/* <News id="news" /> */}
      <Contact1 id="contact" />
    </Layout>
    </>
  );
}

export default Main;
